import React from 'react';
// import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Input, Row, Col, Popconfirm } from 'antd';
import BasePage from 'components/BasePage';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import Panel from 'components-desktop/Panel';
import helpers from 'misc/helpers';
import TableEraClaims from './components/TableEraClaims';

const propTypes = {
};

@autobind
class UploadEraPage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      tableKey: null,
      eraDetails: null,
      eraDetailsCompany: null,
      isUploadButtonEnable: true,
      isApplyButtonEnable: true,
    };
  }

  getTitle() {
    return 'Upload a 835 Electronic Remittance Advice File';
  }

  onUploadClick() {
    const fileReader = new FileReader();

    fileReader.onload = async (e) => {
      try {
        this.setState({
          isUploadButtonEnable: false,
        });

        const params1 = {
          content: e.target.result,
        };
        const eraDetails = await this.callServiceForRemoteObject('/payment/upload_era', params1);

        const params2 = {
          id: eraDetails.getRemoteObject('payment').getLong('companyId'),
        };
        const company = await this.callServiceForRemoteObject('/company/get_model', params2);

        this.setState({
          tableKey: `${Date.now()}_${Math.random()}`,
          eraDetails,
          eraDetailsCompany: company,
        });
      } finally {
        this.setState({
          isUploadButtonEnable: true,
        });
      }
    };
    fileReader.readAsText(this.state.selectedFile);
  }

  onApplyClick() {
    const fileReader = new FileReader();

    fileReader.onload = async (e) => {
      try {
        this.setState({
          isApplyButtonEnable: false,
        });

        const params = { content: e.target.result };
        const paymentId =
          await this.callServiceForLong('/payment/upload_era_and_apply_payments', params);

        this.notifySuccess('Success', 'Payment applied, redirecting to details page...');

        // Go to the new payment's details page.
        setTimeout(() => {
          window.location = `/payments/payment_details?id=${paymentId}`;
        }, 3000);
      } finally {
        this.setState({
          isApplyButtonEnable: true,
        });
      }
    };
    fileReader.readAsText(this.state.selectedFile);
  }

  onResetClick() {
    this.setState({
      selectedFile: null,
      tableKey: null,
      eraDetails: null,
      isUploadButtonEnable: true,
      isApplyButtonEnable: true,
    });
    document.getElementById('edi_file_input').value = '';
  }

  onFileChange(e) {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.files.length > 0 && e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
      });
    }
  }

  renderContent() {
    const {
      selectedFile,
      tableKey,
      eraDetails,
      eraDetailsCompany,
      isUploadButtonEnable,
      isApplyButtonEnable,
    } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="yellow_gold"
          title="Upload a 835 Electronic Remittance Advice File"
          icon="money-collect"
        >
          {/* Content */}
          <FlexRowContainer
            width="match_parent"
            height="wrap_content"
            padding="20px 20px"
            alignItems="center"
          >
            <styledComp.AntdFormItem
              width="400px"
              height="wrap_content"
              margin="0 16px 0 0"
              label="Upload a 835 ERA File"
              extra={`Select a 835 ERA file, and then press the "Upload" button.`}
            >
              <Input
                value={selectedFile?.name}
                disabled
                type="text"
                placeholder="No 835 ERA file selected."
              />
            </styledComp.AntdFormItem>

            <CustomButton
              width="wrap_content"
              height="32px"
              margin="0 4px 0 0"
              backgroundColor="#32c5d2"
              fontSize="14px"
              type="primary"
              onClick={() => this.uploader.click()}
            >
              SELECT...
            </CustomButton>

            <CustomButton
              width="wrap_content"
              height="32px"
              backgroundColor="#3598dc"
              fontSize="14px"
              type="primary"
              disabled={!this.state.selectedFile}
              loading={!isUploadButtonEnable}
              onClick={this.onUploadClick}
            >
              UPLOAD
            </CustomButton>

            <input
              id="edi_file_input"
              ref={(ref) => { this.uploader = ref; }}
              accept=".edi,.txt,.835,.era"
              type="file"
              style={{ display: 'none' }}
              onChange={this.onFileChange}
            />
          </FlexRowContainer>
        </Panel>

        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="yellow_gold"
          title="835 ERA File Details"
          icon="money-collect"
        >
          <FlexColContainer
            width="match_parent"
            height="wrap_content"
          >
            {/* Content */}
            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
            >
              <Row type="flex" gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Payment Method"
                  >
                    <Input
                      value={eraDetails?.getRemoteObject('payment')?.getString('paymentMethod')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Company"
                  >
                    <Input
                      value={eraDetailsCompany?.getString('name')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Check Number"
                  >
                    <Input
                      value={eraDetails?.getRemoteObject('payment')?.getString('checkNumber')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Check Date"
                  >
                    <Input
                      value={eraDetails?.getRemoteObject('payment')?.getString('checkDateUsString')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Received Date"
                  >
                    <Input
                      value={eraDetails?.getRemoteObject('payment')?.getString('receivedDateUsString')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Total Paid"
                  >
                    <Input
                      value={eraDetails && helpers.toDollars(
                        eraDetails?.getRemoteObject('payment')?.getDouble('amount'))}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Total Accepted Claims"
                  >
                    <Input
                      value={eraDetails?.getRemoteObjects('acceptedClaims').length}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Total Rejected Claims"
                  >
                    <Input
                      value={eraDetails?.getRemoteObjects('rejectedClaims').length}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Total Claims with Incorrect Inv #"
                    extra="# of claims whose invoice # is not recognized"
                  >
                    <Input
                      value={eraDetails?.getString('noInvoiceClaimCount')}
                      disabled
                      type="text"
                    />
                  </styledComp.AntdFormItem>
                </Col>
              </Row>
            </FlexColContainer>

            {/* Footer */}
            <FlexRowContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
              justifyContent="center"
              backgroundColor="containerGrayBackground"
            >
              <Popconfirm
                title="Are you sure you want to apply payment?"
                placement="top"
                okText="Confirm"
                cancelText="Cancel"
                onConfirm={this.onApplyClick}
              >
                <CustomButton
                  width="wrap_content"
                  height="32px"
                  margin="0 4px 0 0"
                  backgroundColor="yellow_gold"
                  fontSize="14px"
                  type="primary"
                  disabled={!eraDetails}
                  loading={!isApplyButtonEnable}
                >
                  APPLY PAYMENT
                </CustomButton>
              </Popconfirm>

              <styledComp.AntdButton
                width="wrap_content"
                height="32px"
                fontSize="14px"
                type="default"
                onClick={this.onResetClick}
              >
                RESET
              </styledComp.AntdButton>
            </FlexRowContainer>
          </FlexColContainer>
        </Panel>

        {eraDetails &&
          <TableEraClaims
            key={`${tableKey}_rejected`}
            width="match_parent"
            height="wrap_content"
            margin="0 0 24px 0"
            title="Rejected Claims (Including Zero Paid Payments)"
            claims={eraDetails.getRemoteObjects('rejectedClaims')}
          />
        }

        {eraDetails &&
          <TableEraClaims
            key={`${tableKey}_accepted`}
            width="match_parent"
            height="wrap_content"
            margin="0 0 24px 0"
            title="Accepted Claims (Including Reversal (Negative) Payments)"
            claims={eraDetails.getRemoteObjects('acceptedClaims')}
          />
        }
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
UploadEraPage.propTypes = propTypes;

export default UploadEraPage;
